import { useSelector } from 'react-redux';
import type { RootState } from '@/store';

export const useFeatureFlags = () => {
  const featureFlags = useSelector((state: RootState) => state.organization.settings?.featureFlags || {});
  
  const isEnabled = (flag: string): boolean => {
    return featureFlags[flag] === true;
  };

  return {
    featureFlags,
    isEnabled,
    positionAnalysisEnabled: isEnabled('positionAnalysisEnabled'),
    addressAutocompleteEnabled: isEnabled('addressAutocompleteEnabled'),
    oauthEnabled: isEnabled('oauthEnabled')
  };
};
